import React from 'react';
import { XIcon, CheckIcon, ShieldIcon, ActivityIcon, ZapIcon } from 'lucide-react';
export function WhyThisWorksSection() {
  const problems = ['Dietas extremas que te dejan con hambre, ansiedad y mal humor', 'Matarte a cardio y sentir que tu cuerpo no cambia (metabolismo estancado)', 'Pagar el gimnasio y no ir porque te da pereza o no tenés tiempo', 'Hacer rutinas sueltas de YouTube sin ningún orden ni resultados reales', 'Sufrir dolor de rodillas o espalda por hacer ejercicios de alto impacto', 'Empezar con todo los lunes y terminar abandonando los viernes por frustración', 'Terminar el día sintiéndote súper hinchada, pesada y sin energía', 'Sentir que la ropa te aprieta y no estar cómoda con tu propio cuerpo', 'Creer que "no tenés disciplina" cuando en realidad el método era el problema'];
  const solutions = [{
    title: 'Cero impacto',
    desc: 'Protege tus articulaciones y espalda usando la pared como soporte.'
  }, {
    title: 'Baja el cortisol',
    desc: 'Desinflama tu cuerpo en vez de estresarlo (como hace el cardio extremo).'
  }, {
    title: 'Tensión constante',
    desc: 'La pared actúa como una pesa natural para tonificar más rápido.'
  }, {
    title: 'Solo 20 minutos',
    desc: 'Rutinas cortas y efectivas que sí vas a poder sostener en el tiempo.'
  }, {
    title: 'Alimentación real',
    desc: 'Recetas ricas, fáciles y sin prohibiciones (chau efecto rebote).'
  }, {
    title: 'Guía visual clara',
    desc: 'Videos demostrativos cortos de cada ejercicio para que sepas la técnica exacta.'
  }, {
    title: 'Resultados visibles',
    desc: 'Abdomen más plano, piernas firmes y mejor postura en semanas.'
  }];
  const steps = [{
    number: '1',
    title: 'Abrís tu plan',
    description: 'Todo organizado día por día. Sin pensar qué hacer.'
  }, {
    number: '2',
    title: 'Entrenás 20 min',
    description: 'Mirás los videos cortos de demostración y hacés la rutina a tu propio ritmo.'
  }, {
    number: '3',
    title: 'Ves los cambios',
    description: 'Menos inflamación y más firmeza semana a semana.'
  }];
  return <section className="py-12 md:py-16 bg-white" data-id="element-253">
      <div className="max-w-5xl mx-auto px-4 md:px-6" data-id="element-254">
        <div className="text-center mb-10" data-id="element-255">
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-gray-900 mb-4" data-id="element-256">
            TODO LO QUE NECESITÁS EN UN SOLO LUGAR
          </h2>
          <p className="text-base md:text-lg text-gray-700 max-w-2xl mx-auto font-medium" data-id="element-257">
            Diseñado específicamente para mujeres que tienen poco tiempo, están
            cansadas de las dietas restrictivas y quieren resultados reales
            entrenando desde casa.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8 max-w-4xl mx-auto mb-12" data-id="element-258">
          {/* Lo que NO funciona */}
          <div className="bg-rose-50 rounded-2xl p-6 md:p-8 border border-rose-100" data-id="element-259">
            <h3 className="text-xl font-bold text-rose-900 mb-4" data-id="element-260">
              Lo que venías haciendo (y falla)
            </h3>
            <div className="space-y-4" data-id="element-261">
              {problems.map((problem, i) => <div key={i} className="flex items-start gap-3" data-id="element-262">
                  <div className="bg-rose-200 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-263">
                    <XIcon className="w-4 h-4 text-rose-700" data-id="element-264" />
                  </div>
                  <p className="text-gray-800 font-medium" data-id="element-265">{problem}</p>
                </div>)}
            </div>
          </div>

          {/* Lo que SÍ funciona */}
          <div className="bg-emerald-50 rounded-2xl p-6 md:p-8 border border-emerald-100" data-id="element-266">
            <h3 className="text-xl font-bold text-emerald-900 mb-4" data-id="element-267">
              El Método Wall Pilates
            </h3>
            <div className="space-y-4" data-id="element-268">
              {solutions.map((solution, i) => <div key={i} className="flex items-start gap-3" data-id="element-269">
                  <div className="bg-emerald-200 rounded-full p-1 mt-0.5 flex-shrink-0" data-id="element-270">
                    <CheckIcon className="w-4 h-4 text-emerald-700" data-id="element-271" />
                  </div>
                  <p className="text-gray-800 font-medium" data-id="element-272">
                    <span className="font-bold" data-id="element-273">{solution.title}:</span>{' '}
                    {solution.desc}
                  </p>
                </div>)}
            </div>
          </div>
        </div>

        {/* How it works */}
        <div className="bg-cream-50 rounded-3xl p-8 md:p-10 border border-cream-100 max-w-4xl mx-auto" data-id="element-274">
          <h3 className="font-display text-2xl md:text-3xl text-center mb-8 text-gray-900" data-id="element-275">
            ASÍ DE SIMPLE ES EMPEZAR 👇
          </h3>
          <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-276">
            {steps.map((step, i) => <div key={i} className="text-center" data-id="element-277">
                <div className="w-12 h-12 bg-brand-pink-600 text-white rounded-full flex items-center justify-center text-xl font-bold mx-auto mb-4 shadow-md" data-id="element-278">
                  {step.number}
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-279">
                  {step.title}
                </h4>
                <p className="text-sm text-gray-700 leading-snug" data-id="element-280">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}